import { useAtomValue } from 'jotai';
import callApi, { isCancellationResponse } from 'lib/callApi';
import React, { useEffect, useState } from 'react';
import { showFailureToast } from 'lib/ToastHelper';
import Select from 'react-select';
import { companyIdAtom } from 'views/state';

export type PolicyValueType = 'all' | number;

interface PolicyFilterDropdownProps {
  selectedPolicyId: PolicyValueType;
  for_hosts?: number[];
  onChange: (selectedId: PolicyValueType) => void;
}

interface Policy {
  id: number;
  display_name: string;
}

const PolicyFilterDropdown: React.FC<PolicyFilterDropdownProps> = ({
  selectedPolicyId,
  for_hosts,
  onChange,
}) => {
  const companyId = useAtomValue(companyIdAtom);
  const [policyData, setPolicyData] = useState<Policy[]>([]);

  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        if (companyId && companyId !== -1) {
          const params = {
            company_id: companyId,
          };

          if (Array.isArray(for_hosts) && for_hosts.length > 0) {
            params['for_hosts'] = for_hosts.join(',');
          }

          const responseData = await callApi('pcm/policies/', 'GET', params);

          if (isCancellationResponse(responseData)) {
            console.log('Request was cancelled');
            return;
          }

          setPolicyData(responseData?.data);
        }
      } catch (error) {
        const errorMessage = 'Failed to load data.';
        showFailureToast(errorMessage);
        console.error(error);
      }
    };

    fetchPolicies();
  }, [companyId, for_hosts]);

  const getPolicyOptions = () => {
    const options: any[] = [];
    if (policyData && policyData.length > 0) {
      policyData.forEach((policy) => {
        options.push({ value: policy.id, label: policy.display_name });
      });
    }
    return options;
  };

  const policyFilterOptions = [
    { value: 'all', label: 'All Policies' },
    ...getPolicyOptions(),
  ];

  return (
    <Select
      id="PolicyFilterDropdown"
      className="custom-360-dropdown"
      value={policyFilterOptions.find((x) => x.value === selectedPolicyId)}
      onChange={(e) => {
        if (e) {
          onChange(e.value as PolicyValueType);
        }
      }}
      options={policyFilterOptions}
      styles={{
        control: (provided, _) => ({
          ...provided,
          cursor: 'pointer',
        }),
        option: (provided, _) => ({
          ...provided,
          cursor: 'pointer',
        }),
      }}
      placeholder="Select Policy"
    />
  );
};

export default PolicyFilterDropdown;
